/* This file is autogenerated, see readme.md for instructions */
import HistorySvgIcon from '@bloomreach/banana-theme/icons/history.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const HistoryIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <HistorySvgIcon />
    </Icon>
  );
});

HistoryIcon.displayName = 'HistoryIcon';

export default HistoryIcon;
